import React, { Component } from "react";
import Input from "../../UI/Input/MaterialInput";
import Button from "../../UI/Button/MaterialButton";
import {
  getWebsiteLanguageGuid,
  getLabelText,
  getLanguageResourceElasticIndex,
  getServiceUrl,
  getNextJSServiceUrl,
} from "../../config";
import { getPageResource, sanitiseValuesByTypeOfData } from "../../utility";
import axios from "axios";
import Spinner from "../../UI/Spinner/Spinner";
import toaster from "toasted-notes";
import { toasterAlert } from "../../utility";
import { Link } from "react-router-dom";
import jwt from "jsonwebtoken";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
// import Visibility from "@material-ui/icons/Visibility";
// import VisibilityOff from "@material-ui/icons/VisibilityOff";
import visibilityOff from "../../assets/svgIcons/visibilityOff.svg";
import visibilityOn from "../../assets/svgIcons/visibilityOn.svg";
import {
  ReCaptchaContext,
  captchaValidation,
} from "../../google-invisible-recaptcha/RecaptchaProvider";
import { detect } from "detect-browser";
import ToManyRequestMessage from "../../components/Common/ToManyRequestMessage";
let disabled = true;

const initialState = {
  setNewPasswordForm: {
    newPassword: {
      elementType: "input_2",
      // elementConfig: {
      //     type: "password",
      //     placeholder: "",
      // },
      value: "",
      validation: {
        required: true,
        passwordFormat: true,
        maxLength: 15,
        matchPassword: false,
      },
      requiredclass: "required",
      errorMessage: "New Password is required",
      valid: false,
      touched: false,
      formControlProps: { fullWidth: true },
      label: "Enter your new password",
    },
    confirmPassword: {
      elementType: "input_2",
      // elementConfig: {
      //     type: "password",
      //     placeholder: "",
      // },
      value: "",
      validation: {
        required: true,
        passwordFormat: true,
        matchPassword: true,
        maxLength: 15,
      },
      requiredclass: "required",
      errorMessage: "Confirm Password is required",
      valid: false,
      touched: false,
      formControlProps: { fullWidth: true },
      label: "Confirm new password",
    },
  },
  formIsValid: false,
  resources: [],
  encryptedUserGuid: null,
  successfullBlock: false,
  passwordBlock: true,
  loading: false,
};
class SetNewPassword extends Component {
  static contextType = ReCaptchaContext;
  constructor(props) {
    super(props);
    this.state = {
      ...initialState,
      showPassword: false,
    };
    this.inputChangedHandler = this.inputChangedHandler.bind(this);
  }

  componentDidMount() {
    this.setState({
      encryptedEmailId: this.props.EncryptedEmailID,
      isOpsToken: this.props.isOpsToken,
    });

    getPageResource(
      getLanguageResourceElasticIndex(getWebsiteLanguageGuid(), "loginpage")
    ).then((json) => {
      this.setState({ resources: json });
    });
  }

  checkValidity(updatedFormElement) {
    let isValid = true;
    if (!updatedFormElement.validation) {
      isValid = true;
    }
    if (updatedFormElement.validation.required) {
      isValid =
        updatedFormElement.value.trim() !== "" &&
        updatedFormElement.value !== "0" &&
        isValid;
      if (updatedFormElement.value === "") {
        updatedFormElement.errorMessage =
          updatedFormElement.label + " is required.";
      }
      if (updatedFormElement.value.length === 0) {
        isValid = false && isValid;
      }
    }

    updatedFormElement.valid = isValid;
    updatedFormElement.touched = true;
    return updatedFormElement;
  }

  checkValidityOnBlur(updatedFormElement) {
    let isValid = true;
    if (!updatedFormElement.validation) {
      isValid = true;
    }
    if (updatedFormElement.validation.required) {
      isValid =
        updatedFormElement.value.trim() !== "" &&
        updatedFormElement.value !== "0" &&
        isValid;
      if (updatedFormElement.value === "") {
        updatedFormElement.errorMessage =
          updatedFormElement.label + " is required.";
      }
    }

    if (updatedFormElement.validation.matchPassword && isValid) {
      const PasswordForm = { ...this.state.setNewPasswordForm };
      if (
        PasswordForm.newPassword.value !== "" &&
        PasswordForm.newPassword.value !== null &&
        PasswordForm.newPassword.value !== undefined
      ) {
        if (PasswordForm.newPassword.value !== updatedFormElement.value) {
          isValid = false;
          updatedFormElement.errorMessage = "Passwords must match";
        } else {
          updatedFormElement.errorMessage = "";
          PasswordForm.newPassword.errorMessage = "";
          PasswordForm.newPassword.IsValid = isValid;
        }
      }
    }
    if (
      updatedFormElement.validation.matchPassword == false &&
      isValid == true
    ) {
      const PasswordForm = { ...this.state.setNewPasswordForm };
      if (
        PasswordForm.confirmPassword.value !== "" &&
        PasswordForm.confirmPassword.value !== null &&
        PasswordForm.confirmPassword.value !== undefined
      ) {
        if (PasswordForm.confirmPassword.value !== updatedFormElement.value) {
          isValid = false;
          updatedFormElement.errorMessage = "Passwords must match";
        } else {
          updatedFormElement.errorMessage = "";
          PasswordForm.confirmPassword.errorMessage = "";
          PasswordForm.confirmPassword.IsValid = isValid;
        }
      }
    }

    if (updatedFormElement.validation.passwordFormat && isValid) {
      if (updatedFormElement.value.length < 8) {
        isValid = false && isValid;
      }
      var rePasswordFormat = /[0-9]/;
      if (!rePasswordFormat.test(updatedFormElement.value)) {
        isValid = false && isValid;
      }
      rePasswordFormat = /[a-z]/;
      if (!rePasswordFormat.test(updatedFormElement.value)) {
        isValid = false && isValid;
      }
      rePasswordFormat = /[A-Z]/;
      if (!rePasswordFormat.test(updatedFormElement.value)) {
        isValid = false && isValid;
      }
      //rePasswordFormat = /[!@#$%^&*(),.?":{}|<>]/;
      rePasswordFormat = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[@#$%])[a-zA-Z0-9@#$%]+$/;
      if (!rePasswordFormat.test(updatedFormElement.value)) {
        isValid = false && isValid;
      }
      if (!isValid) {
        updatedFormElement.errorMessage =
          "Password is not as per the mentioned policy";
      } else {
        // updatedFormElement.label = '';
      }
    }
    if (updatedFormElement.validation.maxLength && isValid) {
      isValid =
        updatedFormElement.value.length <=
        updatedFormElement.validation.maxLength;
      if (!isValid) {
        updatedFormElement.errorMessage =
          updatedFormElement.label + " length is exceeded";
      }
    }
    updatedFormElement.valid = isValid;
    updatedFormElement.touched = true;
    return updatedFormElement;
  }
  checkValiditionOnSubmit(updatedFormElement) {
    let isValid = true;
    if (!updatedFormElement.validation) {
      isValid = true;
    }
    if (updatedFormElement.validation.required) {
      isValid =
        updatedFormElement.value.trim() !== "" &&
        updatedFormElement.value !== "0" &&
        isValid;
      if (updatedFormElement.value === "") {
        updatedFormElement.errorMessage =
          updatedFormElement.label + " is required.";
      }
    }
    if (updatedFormElement.validation.matchPassword && isValid) {
      const PasswordForm = { ...this.state.setNewPasswordForm };
      if (PasswordForm.newPassword.value !== updatedFormElement.value) {
        isValid = false;
        updatedFormElement.errorMessage = "Passwords must match";
      }
    }
    if (updatedFormElement.label === "Confirm Password") {
      if (updatedFormElement.validation.matchPassword && isValid) {
        const PasswordForm = { ...this.state.setNewPasswordForm };
        if (PasswordForm.newPassword.value !== updatedFormElement.value) {
          isValid = false;
          updatedFormElement.errorMessage = "Passwords must match";
        }
      }
    }

    if (updatedFormElement.validation.passwordFormat && isValid) {
      if (updatedFormElement.value.length < 8) {
        isValid = false && isValid;
      }
      var rePasswordFormat = /[0-9]/;
      if (!rePasswordFormat.test(updatedFormElement.value)) {
        isValid = false && isValid;
      }
      rePasswordFormat = /[a-z]/;
      if (!rePasswordFormat.test(updatedFormElement.value)) {
        isValid = false && isValid;
      }
      rePasswordFormat = /[A-Z]/;
      if (!rePasswordFormat.test(updatedFormElement.value)) {
        isValid = false && isValid;
      }
      //rePasswordFormat = /[!@#$%^&*(),.?":{}|<>]/;
      rePasswordFormat = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[@#$%])[a-zA-Z0-9@#$%]+$/;
      if (!rePasswordFormat.test(updatedFormElement.value)) {
        isValid = false && isValid;
      }
      if (!isValid) {
        updatedFormElement.errorMessage =
          "Password is not as per the mentioned policy";
      }
    }
    if (updatedFormElement.validation.maxLength && isValid) {
      isValid =
        updatedFormElement.value.length <=
        updatedFormElement.validation.maxLength;
      if (!isValid) {
        updatedFormElement.errorMessage =
          updatedFormElement.label + " length is exceeded";
      }
    }
    updatedFormElement.valid = isValid;
    updatedFormElement.touched = true;
    return updatedFormElement;
  }

  inputChangedHandler(event, inputIdentifier) {
    event.preventDefault();
    const updatedSetNewPasswordForm = {
      ...this.state.setNewPasswordForm,
    };
    const updatedFormElement = {
      ...updatedSetNewPasswordForm[inputIdentifier],
    };
    updatedFormElement.value = sanitiseValuesByTypeOfData(event.target.value);
    updatedSetNewPasswordForm[inputIdentifier] = this.checkValidity(
      updatedFormElement
    );
    updatedSetNewPasswordForm[inputIdentifier] = this.checkValidityOnBlur(
      updatedFormElement
    );
    if (
      updatedSetNewPasswordForm.confirmPassword.valid === true &&
      updatedSetNewPasswordForm.newPassword.valid === true
    ) {
      disabled = false;
    } else {
      disabled = true;
    }

    let formIsValid = false;
    for (let inputIndentifiers in updatedSetNewPasswordForm) {
      formIsValid =
        updatedSetNewPasswordForm[inputIndentifiers].valid && formIsValid;
    }

    this.setState({
      setNewPasswordForm: updatedSetNewPasswordForm,
      formIsValid: formIsValid,
    });
  }
  enterPasswordInputChangedHandlerOnBlur(event, inputIdentifier) {
    event.preventDefault();
    const updatedSetNewPasswordForm = {
      ...this.state.setNewPasswordForm,
    };
    let updatedFormElement = {
      ...updatedSetNewPasswordForm[inputIdentifier],
    };
    updatedFormElement.value = sanitiseValuesByTypeOfData(event.target.value);
    updatedFormElement = this.checkValidityOnBlur(updatedFormElement);
    updatedSetNewPasswordForm[inputIdentifier].errorMessage =
      updatedFormElement.errorMessage;
    updatedSetNewPasswordForm[inputIdentifier].valid = updatedFormElement.valid;
    updatedSetNewPasswordForm[inputIdentifier].touched =
      updatedFormElement.touched;
    if (inputIdentifier === "confirmPassword") {
      let updateNewPassword = this.checkValidityOnBlur(
        updatedSetNewPasswordForm["newPassword"]
      );
      updatedSetNewPasswordForm["newPassword"].errorMessage =
        updateNewPassword.errorMessage;
      updatedSetNewPasswordForm["newPassword"].valid = updateNewPassword.valid;
      updatedSetNewPasswordForm["newPassword"].touched =
        updateNewPassword.touched;
    }

    if (
      updatedSetNewPasswordForm.confirmPassword.valid === true &&
      updatedSetNewPasswordForm.newPassword.valid === true
    ) {
      disabled = false;
    } else {
      disabled = true;
    }

    let formIsValid = true;
    for (let inputIndentifiers in updatedSetNewPasswordForm) {
      formIsValid =
        updatedSetNewPasswordForm[inputIndentifiers].valid && formIsValid;
    }

    this.setState({
      setNewPasswordForm: updatedSetNewPasswordForm,
      formIsValid: formIsValid,
    });
  }
  checkFormValidityOnSubmit = () => {
    const updatedSetNewPasswordForm = {
      ...this.state.setNewPasswordForm,
    };

    for (let inputIndentifiers in updatedSetNewPasswordForm) {
      let updatedFormElement = {
        ...updatedSetNewPasswordForm[inputIndentifiers],
      };
      updatedFormElement = this.checkValiditionOnSubmit(updatedFormElement);

      updatedSetNewPasswordForm[inputIndentifiers].valid =
        updatedFormElement.valid;
      updatedSetNewPasswordForm[inputIndentifiers].errorMessage =
        updatedFormElement.errorMessage;
      updatedSetNewPasswordForm[
        inputIndentifiers
      ].touched = !updatedSetNewPasswordForm[inputIndentifiers].valid;
    }
    let isValid =
      updatedSetNewPasswordForm.newPassword.value ===
      updatedSetNewPasswordForm.confirmPassword.value
        ? true
        : false;

    if (
      updatedSetNewPasswordForm.confirmPassword.valid === true &&
      updatedSetNewPasswordForm.newPassword.valid === true
    ) {
      disabled = false;
    } else {
      disabled = true;
    }

    this.setState({
      setNewPasswordForsm: updatedSetNewPasswordForm,
      formIsValid: isValid,
    });

    return isValid;
  };

  submitHandler = async (event) => {
    event.preventDefault();
    const browser = detect();
    const isCaptchaValid = await captchaValidation(this.context);
    if (isCaptchaValid) {
      const formData = {};
      for (let formElementIdentifier in this.state.setNewPasswordForm) {
        formData[formElementIdentifier] = this.state.setNewPasswordForm[
          formElementIdentifier
        ].value;
      }

      let IsValid = this.checkFormValidityOnSubmit();
      if (
        this.state.formIsValid &&
        IsValid &&
        formData.confirmPassword !== ""
      ) {
        this.setState({ loading: true });
        const decodedToken = jwt.decode(this.state.encryptedEmailId);
        let decryptedemail = "";
        let IsInternalRequest = "";
        if (decodedToken !== null) {
          decryptedemail =
            decodedToken["https://hasura.io/jwt/claims"]["x-hasura-user-email"];
          IsInternalRequest =
            decodedToken["https://hasura.io/jwt/claims"][
              "x-hasura-IsInternalRequest"
            ];
        }
        if (IsInternalRequest) {
          var config = {
            headers: {
              Authorization: "Bearer " + localStorage.tokenId,
              "Content-Type": "application/json",
              encryptedEmailId: decryptedemail,
              Password: formData.confirmPassword,
            },
          };
          const options = {
            method: "POST",
            url:
              getNextJSServiceUrl() +
              "InternalAssessment/SetNewPasswordForInternalAssessment",
            headers: {
              Accept: "*/*",
              "Content-Type": "application/json",
              Authorization: "Bearer " + localStorage.tokenId,
            },
            data: {
              EmailId: sanitiseValuesByTypeOfData(decryptedemail),
              Password: sanitiseValuesByTypeOfData(formData.confirmPassword),
              Formid: decodedToken["https://hasura.io/jwt/claims"]["x-hasura-formid"]
            },
          };
          axios.request(options).then((response) => {
            if (response.data !== null) {
              this.setState({
                loading: false,
              });
              if (response.data.saveresult === "Success") {
                this.setState({
                  successfullBlock: true,
                  passwordBlock: false,
                });
              } else {
                toaster.notify(
                  toasterAlert("FAIL", response.data.saveresult, {
                    duration: null,
                  })
                );
              }
            }
          }).catch((err) => {
            if (err.response.status === 429) {
              // Rate limit error
              this.setState({ toManyRequestMessage: "Too many requests. Please try again later.", loading: false });
            }
          });
        } else {
          var config2 = {
            headers: {
              Authorization: "Bearer " + localStorage.tokenId,
              "Content-Type": "application/json",
              encryptedEmailId: this.state.encryptedEmailId,
              Password: formData.confirmPassword,
            },
          };
          const options = {
            method: "GET",
            url:
              getNextJSServiceUrl() +
              "reset-password/SetNewPasswordForSupplier",
            headers: {
              encryptedEmailId: sanitiseValuesByTypeOfData(this.state.encryptedEmailId),
              Password: sanitiseValuesByTypeOfData(formData.confirmPassword),
              emailToken: sanitiseValuesByTypeOfData(this.props.Emailtoken),
              "Content-Type": "application/json",
              Authorization: "Bearer " + localStorage.tokenId,
              BrowserToken: sanitiseValuesByTypeOfData(localStorage.getItem("BrowserToken")),
              BrowserName: sanitiseValuesByTypeOfData(browser.name),
              isOpsToken: sanitiseValuesByTypeOfData(this.state.isOpsToken),
            },
          };
          axios.request(options).then((response) => {
            if (response.data !== null) {
              this.setState({
                loading: false,
              });
              if (response.data.saveresult === "Success") {
                this.setState({
                  successfullBlock: true,
                  passwordBlock: false,
                });
              } else {
                toaster.notify(
                  toasterAlert("FAIL", response.data.saveresult, {
                    duration: null,
                  })
                );
              }
            }
          }).catch((err) => {
            if (err.response.status === 429) {
              // Rate limit error
              this.setState({ toManyRequestMessage: "Too many password reset requests. Please try again later.", loading: false });
            }
          });
        }
      } else {
        const updatedSetNewPasswordForm = { ...this.state.setNewPasswordForm };
        for (let inputIndentifiers in updatedSetNewPasswordForm) {
          updatedSetNewPasswordForm[
            inputIndentifiers
          ].touched = !updatedSetNewPasswordForm[inputIndentifiers].valid;
        }
        this.setState({
          setNewPasswordForm: updatedSetNewPasswordForm,
        });
      }
    } else {
      alert("Captcha verification failed. Please try again.");
    }
  };
  backToLogin = (e) => {
    this.props.PasswordChanged(e);
    //window.location.pathname = '/supplierlogin';
  };
  handleMouseDownPassword = (event, id) => {
    event.preventDefault();
    this.setState((prevState) => ({
      showPassword: {
        ...prevState.showPassword,
        [id]: !prevState.showPassword[id],
      },
    }));
  };
  render() {
    const { resources } = this.state;
    const formElementsArray = [];

    for (let key in this.state.setNewPasswordForm) {
      formElementsArray.push({
        id: key,
        config: this.state.setNewPasswordForm[key],
      });
    }
    return (
      <React.Fragment>
        <div
          id="login_form_inputs"
          style={{ display: this.state.loading ? "none" : "block" }}
        >
          {this.state.passwordBlock === true ? (
            <div>
              <h5>
                {getLabelText(
                  resources.filter((x) => {
                    return x.resourceKey === "resetpasswordlbl";
                  })[0],
                  "Set New Password"
                )}
              </h5>
              <div>
                <p className="reset_password_lable">
                  {getLabelText(
                    resources.filter((x) => {
                      return x.resourceKey === "enterpasswordlbl";
                    })[0],
                    "Please enter your new password."
                  )}
                </p>
                <p className="password_condition">
                  {getLabelText(
                    resources.filter((x) => {
                      return x.resourceKey === "emailformat";
                    })[0],
                    "Your password should contain atleast 8 characters with 1 caps, 1 small, 1 numeric and 1 special character (@#$%)."
                  )}
                </p>
                {formElementsArray.map((formElement) => (
                  <div>
                    <Input
                      class={"required newInput_2"}
                      key={formElement.id}
                      label={formElement.config.label}
                      elementType={formElement.config.elementType}
                      elementConfig={{
                        placeholder: "",
                        type: this.state.showPassword[formElement.id]
                          ? "text"
                          : "password",
                      }}
                      onBlur={(event) =>
                        this.enterPasswordInputChangedHandlerOnBlur(
                          event,
                          formElement.id
                        )
                      }
                      invalid={!formElement.config.valid}
                      shouldValidate={formElement.config.validation}
                      touched={formElement.config.touched}
                      errorMessage={formElement.config.errorMessage}
                      formControlProps={formElement.config.formControlProps}
                      changed={(event) =>
                        this.inputChangedHandler(event, formElement.id)
                      }
                      style={{ padding: "6px 12px 7px !important" }}
                      endIcon={
                        <InputAdornment position="end" class="showHidePass">
                          <IconButton
                            aria-label="Toggle password visibility"
                            onMouseDown={(event) =>
                              this.handleMouseDownPassword(
                                event,
                                formElement.id
                              )
                            }
                            className={
                              formElement.config.value
                                ? "visibleUndisable"
                                : "visibleDisable"
                            }
                          >
                            {this.state.showPassword[formElement.id] ? (
                              <img src={visibilityOn} alt="HidePassword" />
                            ) : (
                              <img src={visibilityOff} alt="showPassword" />
                            )}
                          </IconButton>
                        </InputAdornment>
                      }
                      //onKeyPress={this.enterkey}
                    />
                  </div>
                ))}
              </div>
              {this.state.toManyRequestMessage && (
                <ToManyRequestMessage
                  message={this.state.toManyRequestMessage}
                  onClear={() => this.setState({ toManyRequestMessage: null })}
                />
              )}
              <div className="set_new_pass_sub">
                <React.Fragment>
                  <Button
                    disableRipple={true}
                    disabled={disabled}
                    onClick={(event) => this.submitHandler(event)}
                    className="solid_btn_new"
                  >
                    {getLabelText(
                      resources.filter((x) => {
                        return x.resourceKey === "savebtn";
                      })[0],
                      "Save"
                    )}
                  </Button>
                </React.Fragment>
              </div>
            </div>
          ) : (
            ""
          )}

          {this.state.successfullBlock === true ? (
            <div className="reset_success">
              <div>
                <h4>
                  {getLabelText(
                    resources.filter((x) => {
                      return x.resourceKey === "resetpassword";
                    })[0],
                    "Reset Password Successful"
                  )}
                </h4>
                <p>
                  {getLabelText(
                    resources.filter((x) => {
                      return x.resourceKey === "congratspasswordset";
                    })[0],
                    "Congrats! You have successfully reset your password."
                  )}
                </p>
              </div>
              <div className="set_new_pass_sub">
                <React.Fragment>
                  <Link
                    to="#"
                    onClick={(e) => this.backToLogin(e)}
                    disableRipple={true}
                    orangeSubmit
                  >
                    {getLabelText(
                      resources.filter((x) => {
                        return x.resourceKey === "backtologinbtn";
                      })[0],
                      "Back to Login"
                    )}
                  </Link>
                </React.Fragment>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>

        <div style={{ display: this.state.loading ? "block" : "none" }}>
          <Spinner />
        </div>
      </React.Fragment>
    );
  }
}
export default SetNewPassword;
